"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockchainForChainId = exports.getBlockchainFromChain = exports.getChainFromID = exports.parseBlockchain = exports.chainIdsByBlockchain = exports.CHAIN_IDS_TEST = exports.CHAIN_IDS_DEV = exports.CHAIN_IDS = exports.ChainNames = exports.BRIDGE_IDS = exports.Blockchain = void 0;
const network_1 = require("../constant/network");
var Blockchain;
(function (Blockchain) {
    Blockchain["Neo"] = "neo";
    Blockchain["Ethereum"] = "eth";
    Blockchain["BinanceSmartChain"] = "bsc";
    Blockchain["Zilliqa"] = "zil";
    Blockchain["Arbitrum"] = "arbitrum";
    Blockchain["Polygon"] = "polygon";
    Blockchain["Okc"] = "okc";
    Blockchain["Native"] = "native";
    Blockchain["Btc"] = "btc";
    Blockchain["Carbon"] = "carbon";
    Blockchain["Switcheo"] = "switcheo";
    Blockchain["TradeHub"] = "tradehub";
    Blockchain["PolyNetwork"] = "polynetwork";
    Blockchain["Neo3"] = "neo3";
    Blockchain["Osmosis"] = "osmosis";
    Blockchain["Ibc"] = "ibc";
    Blockchain["Terra"] = "terra";
    Blockchain["CosmosHub"] = "cosmoshub";
    Blockchain["Juno"] = "juno";
    Blockchain["Evmos"] = "evmos";
    Blockchain["Axelar"] = "axelar";
    Blockchain["Stride"] = "stride";
    Blockchain["Kujira"] = "kujira";
    Blockchain["Terra2"] = "terra2";
    Blockchain["Quicksilver"] = "quicksilver";
    Blockchain["Comdex"] = "comdex";
    Blockchain["StafiHub"] = "stafi";
    Blockchain["Persistence"] = "persistence";
    Blockchain["Stargaze"] = "stargaze";
    Blockchain["Canto"] = "canto";
    Blockchain["OmniFlixHub"] = "omniflixhub";
    Blockchain["Agoric"] = "agoric";
    Blockchain["Sommelier"] = "sommelier";
})(Blockchain = exports.Blockchain || (exports.Blockchain = {}));
exports.BRIDGE_IDS = {
    polynetwork: 1,
    ibc: 2,
};
exports.ChainNames = {
    1: "MainNet",
    3: "Ropsten",
    4: "Rinkeby",
    5: "Goerli",
    56: "BSC MainNet",
    97: "BSC TestNet",
    110: "ZIL DevNet",
    111: "ZIL TestNet",
    65: "Okc TestNet",
    66: "Okc MainNet",
    137: "Polygon MainNet",
    80001: "Polygon Mumbai",
    42161: "Arbitrum MainNet",
    421611: "Arbitrum TestNet",
};
exports.CHAIN_IDS = {
    native: 0,
    btc: 1,
    eth: 2,
    neo: 4,
    bsc: 6,
    neo3: 14,
    zil: 18,
    arbitrum: 19,
    okc: 66,
    polygon: 137,
    osmosis: 244,
    terra: 245,
    cosmoshub: 246,
    juno: 247,
    evmos: 248,
    axelar: 249,
    stride: 313,
    kujira: 314,
    terra2: 315,
    quicksilver: 316,
    comdex: 317,
    stafihub: 318,
    persistence: 319,
    stargaze: 320,
    canto: 321,
    omniflixhub: 322,
    agoric: 323,
};
exports.CHAIN_IDS_DEV = {
    eth: 350,
    neo: 5,
    neo3: 88,
    bsc: 79,
    zil: 111,
};
exports.CHAIN_IDS_TEST = {
    eth: 2,
    neo: 5,
    neo3: 88,
    bsc: 79,
    zil: 111,
};
exports.chainIdsByBlockchain = {
    [network_1.Network.MainNet]: exports.CHAIN_IDS,
    [network_1.Network.DevNet]: exports.CHAIN_IDS_DEV,
    [network_1.Network.TestNet]: exports.CHAIN_IDS_TEST,
    [network_1.Network.LocalHost]: exports.CHAIN_IDS_TEST,
};
function parseBlockchain(value) {
    var _a;
    if (value === null || value === undefined)
        return null;
    return (_a = Object.values(Blockchain).find((enumMember) => enumMember.toLowerCase() === value.toLowerCase())) !== null && _a !== void 0 ? _a : null;
}
exports.parseBlockchain = parseBlockchain;
function getChainFromID(id) {
    return Object.keys(exports.CHAIN_IDS).find((key) => exports.CHAIN_IDS[key] === id);
}
exports.getChainFromID = getChainFromID;
const getBlockchainFromChain = (chainId) => {
    switch (chainId) {
        case 1:
        case 3:
        case 4:
        case 5:
            return Blockchain.Ethereum;
        case 56:
        case 97:
            return Blockchain.BinanceSmartChain;
        case 65:
        case 66:
            return Blockchain.Okc;
        case 137:
        case 80001:
            return Blockchain.Polygon;
        case 110:
        case 111:
            return Blockchain.Zilliqa;
        case 42161:
        case 421611:
            return Blockchain.Arbitrum;
    }
    return undefined;
};
exports.getBlockchainFromChain = getBlockchainFromChain;
const blockchainForChainId = (chainId, network = network_1.Network.MainNet) => {
    switch (network) {
        case network_1.Network.MainNet:
            switch (chainId) {
                case 0:
                    return Blockchain.Native;
                case 1:
                    return Blockchain.Btc;
                case 2:
                    return Blockchain.Ethereum;
                case 4:
                    return Blockchain.Neo;
                case 6:
                    return Blockchain.BinanceSmartChain;
                case 14:
                    return Blockchain.Neo3;
                case 9: /* FALLTHROUGH */
                case 18:
                    return Blockchain.Zilliqa;
                case 12: /* FALLTHROUGH */
                case 66:
                    return Blockchain.Okc;
                case 17: /* FALLTHROUGH */
                case 137:
                    return Blockchain.Polygon;
                case 244:
                    return Blockchain.Osmosis;
                case 13: /* FALLTHROUGH */
                case 245:
                    return Blockchain.Terra;
                case 246:
                    return Blockchain.CosmosHub;
                case 5: /* FALLTHROUGH */
                case 247:
                    return Blockchain.Juno;
                case 7: /* FALLTHROUGH */
                case 248:
                    return Blockchain.Evmos;
                case 8: /* FALLTHROUGH */
                case 249:
                    return Blockchain.Axelar;
                case 313:
                    return Blockchain.Stride;
                case 314:
                    return Blockchain.Kujira;
                case 315:
                    return Blockchain.Terra2;
                case 316:
                    return Blockchain.Quicksilver;
                case 12: /* FALLTHROUGH */
                case 317:
                    return Blockchain.Comdex;
                case 318:
                    return Blockchain.StafiHub;
                case 15: /* FALLTHROUGH */
                case 319:
                    return Blockchain.Persistence;
                case 16: /* FALLTHROUGH */
                case 320:
                    return Blockchain.Stargaze;
                case 321:
                    return Blockchain.Canto;
                case 322:
                    return Blockchain.OmniFlixHub;
                case 323:
                    return Blockchain.Agoric;
                case 19: /* FALLTHROUGH */
                case 42161:
                    return Blockchain.Arbitrum;
                default:
                    return undefined;
            }
        case network_1.Network.TestNet:
            switch (chainId) {
                case 1:
                    return Blockchain.Btc;
                case 0:
                case 5:
                    return Blockchain.Carbon;
                case 79:
                    return Blockchain.BinanceSmartChain;
                case 88:
                    return Blockchain.Neo3;
                case 111:
                    return Blockchain.Zilliqa;
                case 2: /* FALLTHROUGH */
                case 502:
                    return Blockchain.Ethereum;
                default:
                    return undefined;
            }
        case network_1.Network.DevNet:
            switch (chainId) {
                case 0:
                    return Blockchain.Carbon;
                case 1:
                    return Blockchain.Btc;
                case 2:
                case 350:
                    return Blockchain.Ethereum;
                case 5:
                    return Blockchain.Neo;
                case 79:
                    return Blockchain.BinanceSmartChain;
                case 111:
                    return Blockchain.Zilliqa;
                default:
                    return undefined;
            }
        case network_1.Network.LocalHost:
            return undefined;
        default:
            return undefined;
    }
};
exports.blockchainForChainId = blockchainForChainId;
